import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import React, { useRef } from "react";
import PropTypes from "prop-types";
import { Picture, Source, Img } from "@xo-union/tk-component-picture";
import styles from "./styles.css";
var Image = function Image(_ref) {
  var imageProps = _ref.imageProps,
    onLoad = _ref.onLoad;
  var id = imageProps.id,
    containerClassName = imageProps.containerClassName,
    imageClassName = imageProps.imageClassName,
    img_ratio = imageProps.img_ratio,
    alt = imageProps.alt,
    ariaHidden = imageProps.ariaHidden,
    desktopWidth = imageProps.desktopWidth,
    desktopHeight = imageProps.desktopHeight,
    mobileWidth = imageProps.mobileWidth,
    mobileHeight = imageProps.mobileHeight,
    smartCrop = imageProps.smartCrop,
    lazy = imageProps.lazy;
  var imageClasses = "".concat(styles.imageContainerImg, " ").concat(imageClassName);
  var containerClasses = "".concat(styles.resultCardImageContainer, " ").concat(containerClassName);
  var imgContainer = useRef(null);
  return /*#__PURE__*/React.createElement("div", {
    className: containerClasses,
    "aria-hidden": ariaHidden,
    ref: imgContainer,
    style: img_ratio && _parseInt(img_ratio) ? {
      paddingBottom: img_ratio,
      height: 0
    } : {}
  }, /*#__PURE__*/React.createElement(Picture, {
    id: id,
    env: "production",
    pixelDensities: [1, 2],
    lazy: lazy,
    elementProps: {
      className: styles.pictureContainer
    }
  }, /*#__PURE__*/React.createElement(Source, {
    viewport: "md",
    width: desktopWidth,
    height: desktopHeight,
    smartCrop: smartCrop
  }), /*#__PURE__*/React.createElement(Source, {
    viewport: "xs",
    width: mobileWidth,
    height: mobileHeight,
    smartCrop: smartCrop
  }), /*#__PURE__*/React.createElement(Img, {
    pixelDensity: 1,
    className: imageClasses,
    width: desktopWidth,
    height: desktopHeight,
    alt: alt,
    smartCrop: smartCrop,
    lazy: lazy,
    onLoad: onLoad
  })));
};
process.env.NODE_ENV !== "production" ? Image.propTypes = {
  imageProps: PropTypes.shape({
    containerClassName: PropTypes.string,
    imageClassName: PropTypes.string,
    alt: PropTypes.string,
    ariaHidden: PropTypes.bool,
    desktopWidth: PropTypes.number,
    desktopHeight: PropTypes.number,
    mobileWidth: PropTypes.number,
    mobileHeight: PropTypes.number,
    smartCrop: PropTypes.bool,
    lazy: PropTypes.bool
  }),
  onLoad: PropTypes.func
} : void 0;
export default Image;